import Grid, { gridClasses, GridProps } from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

export const InnerContainer = styled(Grid)<GridProps>({
  [`&.${gridClasses.root}`]: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: 500,
  },
});

export const OuterContainer = styled(Grid)<GridProps>(({ theme }) => ({
  [`&.${gridClasses.root}`]: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
}));
